import React from 'react';
import Basepage, { BasePageState } from '../Basepage';
import MolLink from '../Basepage/parts/Menu/MolLink';

interface Onlyb2bState extends BasePageState {}
interface Onlyb2bModel {}

export default class Onlyb2bPage extends Basepage<Onlyb2bState, Onlyb2bModel> {
  renderChild(): JSX.Element {
    return (
      <div id="Onlyb2b">
        Der Buchbutler richtet sich ausschließlich an Buchhändler, bzw. an
        Wiederverkäufer, also Kunden, die Bücher nicht für den Eigenbedarf
        bestellen.
        <br />
        Bei Fragen wenden Sie sich gerne an unseren{" "}
        <a href="https://www.buchbutler.de/kontakt" target="_blank">
          Kundenservice
        </a>
        .
        <br />
        <br />
        Sollten Sie Bücher für Ihren Eigenbedarf bei uns bestellen wollen,
        nutzen Sie bitte unseren Shop{" "}
        <a href="https://www.moluna.de" target="_blank">
          www.moluna.de
        </a>
      </div>
    );
  }

  initState(base: BasePageState): Onlyb2bState {
    let newState: Onlyb2bState = {
      ...base,
    };

    return newState;
  }
  getApiReqestUrl(checkOnly: boolean): string {
    return this.state.apiBase + '/Standard.php';
  }
  releaseOneCommand(): void {}
  childDidMount(): void {}
  childDidUnmount(): void {}
  initJSChild(): string {
    return '';
  }
  childDidUpdate(prevProp: any, prevState: any): void {}
  getRightBreadCrumbParts(): JSX.Element {
    return <></>;
  }

  pageHeaderGetter(): string | null {
    return null;
  }
  pageTitleGetter(): string {
    return 'Über Uns';
  }
  getBreadCrumb(): JSX.Element {
    return <span>Über Uns</span>;
  }
  getType(): string {
    return 'Onlyb2bPage';
  }
}
